<template>
  <el-dialog
    class="h-dialog-custom-class"
    :width="width"
    :before-close="onCancel"
    append-to-body
    draggable
    lock-scroll
    :close-on-click-modal="false"
    :show-close="false"
    :model-value="modelValue"
    v-bind="$attrs"
  >
    <template v-for="(value, key) in $slots" :key="key" #[key]>
      <slot :name="key" v-if="key !== 'default'"></slot>
      <template v-else>
        <el-icon
          class="h-dialog-custom-class-x"
          v-if="showClose"
          @click="close"
        >
          <Close />
        </el-icon>
        <slot name="default"> </slot>
      </template>
    </template>
    <template #footer v-if="$props.footer !== false">
      <slot name="footer">
        <el-row justify="end">
          <el-button @click="onCancel" v-if="showCancel">
            <slot name="cancelText">
              {{ cancelText }}
            </slot>
          </el-button>
          <el-button
            type="primary"
            :disabled="confirmLoading"
            :loading="confirmLoading"
            @click="$emit('onOk')"
            v-if="showConfirm"
          >
            <slot name="okText">
              {{ isOk ? okText : $t("commonComponents.ConfirmText") }}
            </slot>
          </el-button>
        </el-row>
      </slot>
    </template>
  </el-dialog>
</template>

<script setup>
import { $t } from "@/i18n";
const emit = defineEmits(["update:modelValue", "onCancel", "onOk"]);
defineExpose({
  show,
  hide,
});

defineProps({
  modelValue: Boolean,
  showConfirm: {
    type: Boolean,
    default: true,
  },
  showClose: {
    type: Boolean,
    default: true,
  },
  showCancel: {
    type: Boolean,
    default: true,
  },
  cancelText: {
    type: String,
    default: () => $t("commonComponents.cancelText"),
  },
  okText: {
    type: String,
    default: () => $t("commonComponents.ConfirmText"),
  },
  confirmLoading: {
    type: Boolean,
    default: false,
  },
  footer: {
    type: Boolean,
    default: true,
  },
  /* 自定义宽度 */
  width: {
    type: String,
    default: "520px",
  },
  isOk: {
    type: Boolean,
    default: true,
  },
});

function onCancel() {
  emit("update:modelValue", false);
  console.log("cancel");
  emit("onCancel");
}

function close() {
  emit("update:modelValue", false);
  console.log("close");
  emit("onCancel");
}

function show() {
  emit("update:modelValue", true);
}

function hide() {
  emit("update:modelValue", false);
}
</script>
<style lang="scss">
.h-dialog-custom-class {
  position: relative;

  .h-dialog-custom-class-x {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
  }
}
</style>
